<template>
    <div>
        <div class="layer" v-show="headerShow">
            <Search />
        </div>
        <div :class="is_full_screen ? '' : 'layer'" class="content">
            <div class="title" :style="{color:data.title_color}">{{ data.title }}</div>
            <div class="Subheading">
                <div class="time" style="margin-right:40px;">上传日期:{{ data.add_time * 1000 | dateFormat('YYYY-MM-DD HH:mm:ss') }}</div>
                <div class="access_count">浏览次数:{{ data.access_count }}</div>
            </div>
            <pre v-html="data.content" class="ue">
            </pre>
        </div>
    </div>
</template>

<script>
import { ArticleService } from '../../service/article.service'
import Search from '@/components/Search/index'

export default {
    data() {
        return {
            data: '',
            customId: '',
            headerShow: true,
            is_full_screen: true
        }
    },
    components: {Search},
    methods: {
        async getData() {
            const data = await ArticleService.customviewDetail(this.customId)
            this.data = JSON.parse(JSON.stringify(data))
            if(data.is_header == 0) {
                this.$store.commit('hideHeader')
                this.headerShow = false
            }
            if(data.is_footer === 0 ) {
                this.$store.commit('hideFooter')
            }
            if(data.is_full_screen === 0 ) {
                this.is_full_screen = false
            }
        }
    },
    created() {
        this.customId = this.$router.currentRoute.params.customId
        this.getData()
    },
    destroyed() {
        this.$store.commit('showHeader')
        this.$store.commit('showFooter')
    }
}
</script>

<style scoped lang="scss">
    .content{
        margin-top: 30px;
        .title{
            font-size: 15px;
            width: 100%;
            text-align: center;
            font-size: 34px;
        }
        .Subheading{
            display: flex;
            flex-direction: row;
            justify-content: center;
            font-size: 15px;
            color: #999;
            margin-top: 8px;
            margin-bottom: 60px;
        }
    }
</style>